import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
@Injectable({
  providedIn: 'root'
})

export class AwpInternalOperationApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }

  updateCiscoA2Sharepoint (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/internalAPI/updateCiscoA2Sharepoint`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  updateDirettivePPMS (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/internalAPI/updateDirettivePPMS`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  changeFortinetSerials (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/internalAPI/changeFortinetSerials`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  changeCiscoSerials (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/internalAPI/changeCiscoSerials`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }
}
